import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import {
  SideMenu,
  PageContentLayout,
  PageHeaderLayout,
} from 'melp-design/components';
import { ROUTES } from 'config';
import { useRouteMatch } from 'react-router-dom';
import { ClaimsDisabledFeatureAlert } from 'containers/claims';

export const ClaimsLayout: FC = ({ children }) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Stack gap={2}>
      <ClaimsDisabledFeatureAlert />

      <PageHeaderLayout
        breadcrumbs={[
          {
            label: t('claims.title'),
          },
        ]}
      />

      <PageContentLayout
        sidebar={
          <SideMenu
            tabs={[
              {
                key: 'claims',
                label: t('claims.title'),
                url: ROUTES.claims.list,
                isActive: path === ROUTES.claims.list,
              },
              {
                key: 'settings',
                label: t('common.settings'),
                url: ROUTES.claims.settings,
                isActive: path === ROUTES.claims.settings,
              },
            ]}
          />
        }
      >
        {children}
      </PageContentLayout>
    </Stack>
  );
};
